export enum ImportSwitchMethod {
  SEED_PHRASE = 'seed-phrase',
  PRIVATE_KEY = 'private-key',
  BACKUP = 'backup',
}
